<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-management-company">
      <div class="sub-title-label">Across all users</div>
      <div class="div-company-name-label">
        Company name
      </div>
      <div class="div-company-name">
        <!-- <el-input v-model="user.companyName" ref="companyNameTxt" size="medium"></el-input> -->
        {{authUser.company.name}}
      </div>
      <div class="time-zone-label">Time Zone</div>
      <div class="div-time-zone-content">
        <el-select
            v-model="selectedTimeZone"
            collapse-tags
            size="mini"
            style="margin-left: 5px;"
            popper-class="time-zone-dropdown"
            placeholder="Select Time Zone">
            <el-option
              v-for="(item) in timeZones"
              :disabled="item.disabled"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';

  export default Vue.extend({
    name: 'wy-management-company',
    data() {
      return {
        user: {
          companyName: ''
        },
        timeZones: [],
        selectedTimeZone: 'utc_toronto'
      }
    },

    computed: {
      ...mapGetters(['authUser']),
    },

    created() {
      this.timeZones = [
        {
          label: 'UTC +04:00 (Toronto)',
          value: 'utc_toronto',
          disabled: false
        },
        {
          label: 'UTC +04:00 (New York)',
          value: 'utc_new_york',
          disabled: false
        },{
          label: 'UTC +09:00 (Paris)',
          value: 'utc_paris',
          disabled: false
        }
      ]
      this.user.companyName ="shaw jive";
    }
  });
</script>

<style lang="scss">
.wy-management-company {
   width: 600px;
  .sub-title-label {
    padding-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
  }
  .div-company-name-label {
    padding-top: 10px;
    font-size: 14px;
    font-weight: 500;
  }
  .div-company-name {
    padding: 20px 0 5px 0;
    color: #004A87;
    border-bottom: 1px solid #D7D7D8;
    font-size: 14px;
    .el-input.el-input--medium {
      width: 300px;
      height: 26px;
      margin-top: 7px;
      padding-left: 0px;
    } 
    input.el-input__inner {
      border-width: 0px 0px 1px 0px !important;
    }
  }
  .time-zone-label {
    padding-top: 40px;
    font-size: 14px;
    font-weight: 500;
  }

  .div-time-zone-content {
    padding-top: 10px;
    .el-input {
      border: 1px solid #D7D7D8;
      border-radius: 5px;
      opacity: 1;
      padding: 0px 10px;
    }
    .el-select.el-select--mini {
      margin-left: 0px !important;
    }
    .el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
      margin-top: 2px;
      padding-left: 0px;
      border-width: 0px 0px 0px 0px !important;
      color: #004A87;
    }
  }
}
</style>